namespace TR {
    export class Filtering {

        transform: any = {
            Stars: { s: this._serializeArray, d: this._deserializeArray },
            BoardTypes: { s: this._serializeArray, d: this._deserializeArray },
            ChildDestinations: { s: this._serializeArray, d: this._deserializeArray },
            FacilityCodes: { s: this._serializeArray, d: this._deserializeArray },
            PropertyTypes: { s: this._serializeArray, d: this._deserializeArray },
            RatingRange: { s: this._serialiseRange, d: this._deserialiseRange },
            PriceRange: { s: this._serialiseRange, d: this._deserialiseRange },
            HolidayPriceRange: { s: this._serialiseRange, d: this._deserialiseRange }
        };

        boardTypes: any = {
            1: 'ROOMONLY',
            2: 'BEDANDBREAKFAST',
            3: 'HALFBOARD',
            4: 'FULLBOARD',
            5: 'ALLINCLUSIVE',
            6: 'SELFCATERING'
        };

        constructor(
            private $location: ng.ILocationService,
            private $q: ng.IQService,
            private FilterIdUtils: any,
            private fidParser: Core.IFidParser
        ) {}

        getFilters(defaultFilters: any = {}, pageStrand) {
            const params = this.$location.search();
            const fid = this.fidParser.parse();

            return fid ?
                this.FilterIdUtils.getFilters(fid, pageStrand)
                    .then(f => this._mergeFromFid(defaultFilters, f)) :
                this.$q.when(this._mergeFromParams(defaultFilters, params));
        }

        deserialiseFilters(rawFilters: any) {
            let filters = {};
            for (let filter in rawFilters) {
                filters[filter] = this.transform[filter].d(rawFilters[filter]);
            }
            return filters;
        }

        serialiseFilters(filterObj: any) {
            let updated = false;
            const paramValues = this.$location.search();
            for (let filter in filterObj) {
                // have to convert to null as non existant parameters are deleted by null value in
                // $location.search
                const paramValue = paramValues[filter] || null;
                const newParamValue = this.transform[filter].s(filterObj[filter]);
                if (paramValue !== newParamValue) {
                    updated = true;
                    this.$location.search(filter, newParamValue);
                }
            }
            return updated;
        }

        getBoardTypeName(bt: number) {
            if (!bt) { return ''; }
            return this.boardTypes[bt];
        }

        private _mergeFromParams(defaultFilters: any, params: any) {
            let filters = {};
            for (let filter in defaultFilters) {
                const f = params[filter]
                    ? this.transform[filter].d(params[filter])
                    : defaultFilters[filter];
                filters[filter] = f;
            }
            return filters;
        }

        private _mergeFromFid(defaultFilters: any, fidFilters: any) {
            let filters = {};
            for (let filter in defaultFilters) {
                const f = fidFilters && fidFilters[filter]
                    ? fidFilters[filter]
                    : defaultFilters[filter];
                filters[filter] = f;
            }
            return filters;
        }

        private _deserializeArray(str: string) {
            return str.split(',');
        }

        private _serializeArray(arr: any[]) {
            if (!arr.length) { return null; }
            return arr.join(',');
        }

        private _deserialiseRange(str: string) {
            const rating = str.split(',');
            return { Min: parseFloat(rating[0] || '0'), Max: parseFloat(rating[1] || '0') };
        }

        private _serialiseRange(range: any) {
            if (!range) { return null; }
            return `${range.Min},${range.Max}`;
        }

    }

    angular
        .module('TR')
        .service('filtering', Filtering);
}
